// @ts-nocheck
// File created by ./scripts/create-asset-map
// DO NOT MODIFY
const assetsMap = new Map();
import Coinnl9t1 from '../icons/assets/1INCH.png';
assetsMap.set('1INCH', Coinnl9t1);
import Coinwxbdm from '../icons/assets/3CRV.png';
assetsMap.set('3CRV', Coinwxbdm);
import Coinlv5y6 from '../icons/assets/AAVE.png';
assetsMap.set('AAVE', Coinlv5y6);
import Coinu8dz2 from '../icons/assets/ADA.png';
assetsMap.set('ADA', Coinu8dz2);
import Coin140hy from '../icons/assets/AERGO.png';
assetsMap.set('AERGO', Coin140hy);
import Coinazzcx from '../icons/assets/ARB.png';
assetsMap.set('ARB', Coinazzcx);
import Coinfpb7y from '../icons/assets/Arkis.png';
assetsMap.set('Arkis', Coinfpb7y);
import Coinou16j from '../icons/assets/arkisHYPE.png';
assetsMap.set('arkisHYPE', Coinou16j);
import Coint31e3 from '../icons/assets/ARKIS_STADA_BITGO.png';
assetsMap.set('ARKIS_STADA_BITGO', Coint31e3);
import Coingvzep from '../icons/assets/ARKIS_STNEAR_BYBIT.png';
assetsMap.set('ARKIS_STNEAR_BYBIT', Coingvzep);
import Coino57a5 from '../icons/assets/ARKIS_WEETH_WITHDRAWAL_NFT.png';
assetsMap.set('ARKIS_WEETH_WITHDRAWAL_NFT', Coino57a5);
import Coin9hi4w from '../icons/assets/ATOM.png';
assetsMap.set('ATOM', Coin9hi4w);
import Coinoyiq9 from '../icons/assets/AVAX.png';
assetsMap.set('AVAX', Coinoyiq9);
import Coinzs4d3 from '../icons/assets/BAL.png';
assetsMap.set('BAL', Coinzs4d3);
import Coina3r24 from '../icons/assets/Blink.png';
assetsMap.set('Blink', Coina3r24);
import Coin5bugq from '../icons/assets/BNB.png';
assetsMap.set('BNB', Coin5bugq);
import Coinsdsa3 from '../icons/assets/BTC.png';
assetsMap.set('BTC', Coinsdsa3);
import Coinz1kop from '../icons/assets/CAKE.png';
assetsMap.set('CAKE', Coinz1kop);
import Cointiyoj from '../icons/assets/Coinbase.png';
assetsMap.set('Coinbase', Cointiyoj);
import Coin93cod from '../icons/assets/COMP.png';
assetsMap.set('COMP', Coin93cod);
import Coin4euzi from '../icons/assets/CRO.png';
assetsMap.set('CRO', Coin4euzi);
import Coincaftj from '../icons/assets/CRV.png';
assetsMap.set('CRV', Coincaftj);
import Coin3lmqc from '../icons/assets/CRV3CRYPTO.png';
assetsMap.set('CRV3CRYPTO', Coin3lmqc);
import Coin01mkn from '../icons/assets/crvFRAX.png';
assetsMap.set('crvFRAX', Coin01mkn);
import Coin77vsp from '../icons/assets/crvUSDETHCRV.png';
assetsMap.set('crvUSDETHCRV', Coin77vsp);
import Coinl55nx from '../icons/assets/CVX.png';
assetsMap.set('CVX', Coinl55nx);
import Coinld841 from '../icons/assets/CVXCRV.png';
assetsMap.set('CVXCRV', Coinld841);
import Coin33sc7 from '../icons/assets/DAI.png';
assetsMap.set('DAI', Coin33sc7);
import Coinr7hme from '../icons/assets/DFI.png';
assetsMap.set('DFI', Coinr7hme);
import Coin6l1kw from '../icons/assets/DOGE.png';
assetsMap.set('DOGE', Coin6l1kw);
import Coinjlrci from '../icons/assets/DOT.png';
assetsMap.set('DOT', Coinjlrci);
import Coin7jw2c from '../icons/assets/ETC.png';
assetsMap.set('ETC', Coin7jw2c);
import Coinxxt80 from '../icons/assets/ETH.png';
assetsMap.set('ETH', Coinxxt80);
import Coinnwiux from '../icons/assets/FRAX.png';
assetsMap.set('FRAX', Coinnwiux);
import Coin7th7b from '../icons/assets/FXS.png';
assetsMap.set('FXS', Coin7th7b);
import Coin21uen from '../icons/assets/GFI.png';
assetsMap.set('GFI', Coin21uen);
import Coin7j6s7 from '../icons/assets/GMX.png';
assetsMap.set('GMX', Coin7j6s7);
import Coinzzfdi from '../icons/assets/HBAR.png';
assetsMap.set('HBAR', Coinzzfdi);
import Coin3408p from '../icons/assets/KsUSDe.png';
assetsMap.set('KsUSDe', Coin3408p);
import Coinrq0to from '../icons/assets/KUSDe.png';
assetsMap.set('KUSDe', Coinrq0to);
import Coin6emq4 from '../icons/assets/LDO.png';
assetsMap.set('LDO', Coin6emq4);
import Coin8p9do from '../icons/assets/LEO.png';
assetsMap.set('LEO', Coin8p9do);
import Coinzcykb from '../icons/assets/LQTY.png';
assetsMap.set('LQTY', Coinzcykb);
import Coindwjsl from '../icons/assets/LTC.png';
assetsMap.set('LTC', Coindwjsl);
import Coinari2l from '../icons/assets/MATIC.png';
assetsMap.set('MATIC', Coinari2l);
import Coinyg3so from '../icons/assets/MEDGE.png';
assetsMap.set('MEDGE', Coinyg3so);
import Coinola7v from '../icons/assets/Metamask.png';
assetsMap.set('Metamask', Coinola7v);
import Coins2xtn from '../icons/assets/OP.png';
assetsMap.set('OP', Coins2xtn);
import Coin1gxv2 from '../icons/assets/OSMO.png';
assetsMap.set('OSMO', Coin1gxv2);
import Coin4hd2m from '../icons/assets/PENDLE.png';
assetsMap.set('PENDLE', Coin4hd2m);
import Coinkqk3y from '../icons/assets/pendleLogo.png';
assetsMap.set('pendleLogo', Coinkqk3y);
import Coinqqpx9 from '../icons/assets/PUMP.png';
assetsMap.set('PUMP', Coinqqpx9);
import Coin6c7os from '../icons/assets/pumpBTC.png';
assetsMap.set('pumpBTC', Coin6c7os);
import Coinfuyzs from '../icons/assets/RLP.png';
assetsMap.set('RLP', Coinfuyzs);
import Coin7pm8a from '../icons/assets/RSETH.png';
assetsMap.set('RSETH', Coin7pm8a);
import Coin9ymw1 from '../icons/assets/SHIB.png';
assetsMap.set('SHIB', Coin9ymw1);
import Coinbh4pp from '../icons/assets/SNX.png';
assetsMap.set('SNX', Coinbh4pp);
import Coin472rn from '../icons/assets/SOL.png';
assetsMap.set('SOL', Coin472rn);
import Coindwv35 from '../icons/assets/SPELL.png';
assetsMap.set('SPELL', Coindwv35);
import Coin0bhmh from '../icons/assets/steCRV.png';
assetsMap.set('steCRV', Coin0bhmh);
import Coinua6kw from '../icons/assets/STETH.png';
assetsMap.set('STETH', Coinua6kw);
import Coinshi38 from '../icons/assets/STG.png';
assetsMap.set('STG', Coinshi38);
import Coinfauz3 from '../icons/assets/SUSHI.png';
assetsMap.set('SUSHI', Coinfauz3);
import Coinvuk7m from '../icons/assets/tETH.png';
assetsMap.set('tETH', Coinvuk7m);
import Coinjctca from '../icons/assets/TRX.png';
assetsMap.set('TRX', Coinjctca);
import Coinqe6c3 from '../icons/assets/UNI.png';
assetsMap.set('UNI', Coinqe6c3);
import Coinc3hl1 from '../icons/assets/UNIBTC.png';
assetsMap.set('UNIBTC', Coinc3hl1);
import Coinhh228 from '../icons/assets/USD.png';
assetsMap.set('USD', Coinhh228);
import Coinr67kg from '../icons/assets/USD0++.png';
assetsMap.set('USD0++', Coinr67kg);
import Coinv3n8h from '../icons/assets/USD0.png';
assetsMap.set('USD0', Coinv3n8h);
import Coinlwfzs from '../icons/assets/USD0USD0++.png';
assetsMap.set('USD0USD0++', Coinlwfzs);
import Coinl6isd from '../icons/assets/USD3.png';
assetsMap.set('USD3', Coinl6isd);
import Coinz05te from '../icons/assets/USDC.png';
assetsMap.set('USDC', Coinz05te);
import Cointqxjy from '../icons/assets/USDT.png';
assetsMap.set('USDT', Cointqxjy);
import Coinboc8x from '../icons/assets/USR.png';
assetsMap.set('USR', Coinboc8x);
import Coin5dvgi from '../icons/assets/USRUSDC.png';
assetsMap.set('USRUSDC', Coin5dvgi);
import Coinohjrc from '../icons/assets/USUAL.png';
assetsMap.set('USUAL', Coinohjrc);
import Coincvtsc from '../icons/assets/VVS.png';
assetsMap.set('VVS', Coincvtsc);
import Coin4li0h from '../icons/assets/WalletConnect.png';
assetsMap.set('WalletConnect', Coin4li0h);
import Coinybvt8 from '../icons/assets/WAVES.png';
assetsMap.set('WAVES', Coinybvt8);
import Coinsybs7 from '../icons/assets/WBTC.png';
assetsMap.set('WBTC', Coinsybs7);
import Coinoolgl from '../icons/assets/WETH.png';
assetsMap.set('WETH', Coinoolgl);
import Coiny50rl from '../icons/assets/WSTUSR.png';
assetsMap.set('WSTUSR', Coiny50rl);
import Coinj2oob from '../icons/assets/XLM.png';
assetsMap.set('XLM', Coinj2oob);
import Coin2h5fe from '../icons/assets/XRP.png';
assetsMap.set('XRP', Coin2h5fe);
import Coing9ixg from '../icons/assets/XVS.png';
assetsMap.set('XVS', Coing9ixg);
export { assetsMap };
